<template>
  <div class="newBox">
    <div v-if="!lead.GX_RES_ID&&!lag.GX_RES_ID" style="text-align: center;font-size: 20px;color: #a19d9e;font-weight: 600;background-color: #ffffff;height: 150px;line-height: 150px;">
      暂无数据
    </div>
    <div v-else class="showlist">
      <a v-if="lag.GX_RES_ID" :href="'sourceView?sourceId='+lag.GX_RES_ID+'&type='+type" class="lilist" target="_blank">
        <div class="imgBox">
          <img :src="lag.SHOW_THUMB_URL" alt="">
        </div>
        <div class="imgShadow" />
        <!--<div class="tipBox">-->
        <!--<img :src="topmsgPng" alt="">-->
        <!--<span>{{ item.PRIVACY_RULE|changeType }}</span>-->
        <!--</div>-->
        <p class="bookMsg">
          {{ lag.TITLE }}
        </p>
        <span class="times">
          {{ lag.CREATE_DATE }}
        </span>
        <span class="lastBtn">&lt;&lt;上一篇</span>
      </a>
      <span v-else class="lilist" style="background-color: #999;">
        <span class="nodata">到顶了--</span>
      </span>
      <a v-if="lead.GX_RES_ID" :href="'sourceView?sourceId='+lead.GX_RES_ID+'&type='+type" class="lilist" target="_blank">
        <div class="imgBox">
          <img :src="lead.SHOW_THUMB_URL" alt="">
        </div>
        <div class="imgShadow" />
        <!--<div class="tipBox">-->
        <!--<img :src="topmsgPng" alt="">-->
        <!--<span>{{ item.PRIVACY_RULE|changeType }}</span>-->
        <!--</div>-->
        <p class="bookMsg">
          {{ lead.TITLE }}
        </p>
        <span class="times">
          {{ lead.CREATE_DATE }}
        </span>
        <span class="lastBtn">
          &gt;&gt;下一篇
        </span>
      </a>
      <span v-else class="lilist" style="background-color: #999;">
        <span class="nodata">到底了--</span>
      </span>
    </div>
  </div>
</template>
<script>
import { getShowResLoad } from '@/api/api.js'
export default {
  filters: {
    changeType: val => {
      if (val == 1) {
        return '完全公开'
      }
      if (val == 2) {
        return '完全保密'
      }
      if (val == 3) {
        return '付费查阅'
      }
      if (val == 4) {
        return '密码查阅'
      }
    },
    changeBookType: val => {
      if (val == 1) {
        return '智能家谱'
      }
      if (val == 2) {
        return '电子家谱'
      }
    }
  },
  props: ['resId', 'type'],
  data() {
    return {
      currerntPage: 1,
      currentType: '',
      loadAll: false,
      lag: '',
      lead: ''
    }
  },
  mounted() {
    this.initData()
    this.fn()
  },
  methods: {
    fn: function() {
      window.scrollTo(0, 0)
    },
    initData() {
      var obj = {
        resId: this.$route.query.sourceId,
        type: this.$route.query.type
      }
      getShowResLoad(obj).then(res => {
        this.lag = res.data.lag
        this.lead = res.data.lead
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .nodata{
    display: inline-block;
    width: 100%;
    text-align: center;
    font-size: 14px;
    height: 86px;
    line-height: 86px;
    font-weight: 600;
    color: #ffffff;
  }
  .times{
    width: 200px;
    height: 25px;
    display: inline-block;
    position: absolute;
    bottom: 2px;
    right: 10px;
    font-size: 14px;
    color: #ffffff;
    z-index: 6;
    text-align: right;
  }
  .lastBtn{
    width: 100px;
    height: 25px;
    display: inline-block;
    position: absolute;
    bottom: 2px;
    left: 10px;
    font-size: 14px;
    color: #ffffff;
    z-index: 6;
    text-align: left;
  }
  .bookMsg{
    position: absolute;
    top: 15px;
    left: 15px;
    z-index: 6;
    color: #ffffff!important;
    font-weight: 600;
  }
  .imgShadow{
    width: 410px;
    height: 82px;
    position: absolute;
    top: 0;
    z-index: 5;
    background-color: rgba(0, 0, 0, 0.3);
    &:hover{
      background-color: rgba(0, 0, 0, 0);
    }
  }
    ///列表样式
    .pushu_nav{
        overflow: hidden;
        text-align: center;
        background-color: #fff;
        height: 60px;
        line-height: 60px;
        margin-top: 20px;
        margin-bottom: 20px;
        span{
            font-size: 15px;
            color: #333333;
        }
        .names{
            .span_name{
                cursor: pointer;
                color: #333333;
                font-weight: 600;
                font-size: 16px;
            }
        }
        .activenames{
            .span_name{
                cursor: pointer;
                color: #E3003A;
                font-weight: 600;
                font-size: 16px;
            }
        }
    }
    .showlist{
        /*overflow: hidden;*/
        font-size: 0;
      display: inline-block;
      margin-left: 20px;
        .lilist{
          display: inline-block;
          width: 410px;
          height: 86px;
          margin-right: 20px;
          /* background-color: red; */
          position: relative;
          font-size: 0;
          color: #333;
          vertical-align: top;
            .imgBox{
              width: 410px;
              height: 0;
              padding-bottom: 20%;
              overflow: hidden;
              background-color: #999;
                img{
                  width: 100%;
                  margin-top: -50px;
                }
            }

            p{
                color: #333333;
                margin-top: 5px;
                font-size: 15px;
                height: 40px;
                overflow: hidden;
            }
            .tip{
                position: absolute;
                top: 7px;
                left: 9px;
                display: inline-block;
                width: 60px;
                background-color:rgba(0,0,0,.3);
                color: #ffffff;
                height: 20px;
                line-height: 20px;
                font-size: 12px;
                text-align: center;
                border-radius: 2px;
                cursor: pointer;
                &:hover{
                    color: #ed4040;
                }
            }
        }
        .lilist:nth-child(2n){
            margin-right: 0;
        }
    }
    .addMore{
        height: 45px;
        line-height: 45px;
        font-size: 14px;
        color: #999999;
        background-color: #fff;
        border: 1px solid #e5e5e5;
        border-radius: 3px;
        cursor: pointer;
        display: inline-block;
        width: 100%;
        margin-top: 20px;
        transition: 0.5s;
        text-align: center;
        margin-bottom: 60px;
        .addMore_span{
            cursor: pointer;
        }
        &:hover{
            border: 1px solid #E3003A;
            color: #E3003A;
        }
    }
    .tipBox{
        position: absolute;
        width: 27px;
        height: 70px;
        display: inline-block;
        top: 10px;
        left: 20px;
    }
    .tipBox img{
        width: 27px;
        height: 70px;
    }
    .tipBox span{
        position: absolute;
        width: 70px;
        height: 20px;
        top: 31px;
        left: -22px;
        font-size: 12px;
        color: #ffffff;
        transform: rotate(90deg);
    }
    .hovermsg{
        position: absolute;
        z-index: 3;
        width: 159px;
        height: 225px;
        border: 1px solid #ECECEC;
        top: 310px;
        left: 10px;
        background-color: #fff;
        text-align: center;
        transition: 1s;
    }
    .hovermsg .Btype{
        display: inline-block;
        width: 80px;
        text-align: center;
        border: 1px solid #ed4040;
        height: 18px;
        line-height: 18px;
        font-size: 14px;
        border-radius: 3px;
        color: #666;
        margin-top: 10px;
    }
    .hovermsg .hovermsg_div{
        padding-top: 10px;
        height: 36px;
        line-height: 36px;
        img{
            width: 36px;
            height: 36px;
            border-radius: 50%;
            vertical-align: top;
        }
        span{
            font-size: 15px;
            color: #333;
            display: inline-block;
            height: 36px;
            line-height: 36px;
            vertical-align: top;
            margin-left: 10px;
        }
    }
    .hovermsg .showTime{
        margin-top: 10px;
        font-size: 13px;
        color: #333333;
    }
    .hovermsg  .hovermsg_btn{
        height: 40px;
        line-height: 40px;
        background-color: #E3013A;
        width: 120px;
        display: inline-block;
        margin-top: 10px;
        cursor: pointer;
        span{
            color: #ffffff;
            font-size: 16px;
            svg{
                font-size: 18px;
                margin-right: 5px;
            }
        }
        a{
            color: #ffffff;
            font-size: 16px;
        }
    }
    .showlist .lilist .hovermsg p{
        font-size: 16px;
        font-weight: 600;
        padding: 0 10px;
        padding-top: 10px;
        text-align: center;
        height: 40px;
        line-height: 20px;
        overflow: hidden;
        color: #333;
    }
    .lilist:hover >.hovermsg{
        top: 10px;
    }

    .firstcolumn_tip{
        margin-top: 20px;
        height: 68px;
        /*border: 1px solid #f0f0f0;*/
        text-align: center;
        line-height: 68px;
        background-color: #fff;
        font-size: 24px;
        color: #353535;
        font-weight: 600;
        img{
            width:auto;
            height: 29px;
            margin-top: 20px;
        }
    }
    .leftBox{
        width: 880px;
        margin-right: 20px;
        margin-top: 20px;
        float: left;
        .bannerBox{
            width: 880px;
            height: 340px;
            font-size: 0;
            img{
                width:100%;
                height: 340px;
            }
        }
    }
    .rightBox{
        width: 300px;
        margin-top: 20px;
        float: right;
        overflow: hidden;
    }
    .newBox {
        position: relative;
        width: 100%;
        background-color: #fff;
        padding-bottom: 10px;
        .top {
            position: absolute;
            top: 0;
            width: 100%;
            height: 140px;
            top: -180px;
            z-index: 9;
            background-color: #fff;
            .navs {
                height: 40px;
                background-color: #7e6b5a;
                width: 100%;
                .w1200s {
                    width: 1200px;
                    height: 40px;
                    background-color: #7e6b5a;
                    margin: 0 auto;
                    position: relative;
                    .head-ul {
                        display: inline-block;
                        overflow: hidden;
                        height: 40px;
                        background-color: #7e6b5a;
                        li {
                            display: inline-block;
                            margin-top: 10px;
                            a {
                                padding: 5px 14px;
                                margin: 0 5px;
                                cursor: pointer;
                                color: #ffffff;
                            }
                        }
                    }
                    .right_box {
                        display: inline-block;
                        float: right;
                        .login_register {
                            border-radius: 5px;
                            float: right;
                            width: 88px;
                            height: 28px;
                            margin: 5px 20px;
                            line-height: 28px;
                            /*border: 1px solid #ed4040;*/
                            a {
                                display: inline-block;
                                width: 42px;
                                text-align: center;
                                height: 16px;
                                margin-top: 6px;
                                font-size: 12px;
                                line-height: 16px;
                                color: #ffffff;
                            }
                        }
                        .login_register a:nth-of-type(1) {
                            border-right: 1px solid #fff;
                        }
                        .userBox {
                            border-radius: 5px;
                            width: 90px;
                            height: 30px;
                            margin: 5px 20px;
                            line-height: 30px;
                            transition: 0.5s;
                            position: absolute;
                            z-index: 5;
                            right: 0;
                            top: 0;
                            overflow: hidden;
                            &:hover {
                                height: 240px;
                            }
                            .imgBox {
                                width: 30px;
                                height: 30px;
                                border-radius: 50%;
                                display: inline-block;
                                background-color: #e6e6e6;
                                vertical-align: top;
                                cursor: pointer;
                                font-size: 0;
                                img {
                                    width: 30px;
                                    height: 30px;
                                    border-radius: 50%;
                                }
                            }
                            .usercontent {
                                width: 150px;
                                display: inline-block;
                                height: 30px;
                                font-size: 12px;
                                color: #ffffff;
                                /*overflow: hidden;*/
                                margin-left: 5px;
                                cursor: pointer;
                                position: absolute;
                                z-index: 6;
                            }
                            .list {
                                margin-top: 10px;
                                background-color: #fff;
                                li {
                                    text-align: center;
                                    height: 36px;
                                    line-height: 36px;
                                    font-size: 12px;
                                    cursor: pointer;
                                    &:hover {
                                        background-color: #ed4040;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .logoBox {
                width: 444px;
                height: 60px;
                font-size: 0;
                display: inline-block;
                cursor: pointer;
                margin-top: 40px;
                vertical-align: top;
                img {
                    width: 444px;
                    height: 60px;
                }
            }
            .searchbox {
                display: inline-block;
                overflow: hidden;
                float: right;
                margin-top: 45px;
                span {
                    display: inline-block;
                    height: 38px;
                    width: 98px;
                    border: 1px solid #7e6b5a;
                    vertical-align: top;
                    text-align: center;
                    line-height: 40px;
                }
                .keys_input {
                    height: 38px;
                    width: 313px;
                    border-top: 1px solid #7e6b5a;
                    border-bottom: 1px solid #7e6b5a;
                    border-left: 1px solid #7e6b5a;
                    padding-left: 5px;
                    vertical-align: top;
                }
                .btn {
                    display: inline-block;
                    background-color: #7e6b5a;
                    color: #ffffff;
                    line-height: 40px;
                    height: 40px;
                    text-align: center;
                    width: 101px;
                    cursor: pointer;
                }
            }
            .bannerbox {
                width: 100%;
                height: 500px;
                font-size: 0;
                margin-top: 40px;
                position: relative;
                background-position: center center;
                background-size: auto 100%;
                img {
                    width: 100%;
                    height: 500px;
                }
                .numberCount {
                    position: absolute;
                    top: 332px;
                    width: 100%;
                    text-align: center;
                    color: #bb955b;
                    font-family: '微软宋体';
                }
            }
        }
    }
</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
    @media screen and (max-width: 750px) {
        .top{
            display: none;
        }
        .leftBox{
            width: 100%;
            margin-top: 0;
            .bannerBox{
                width: 100%;
                height: auto;
                img{
                    width: 100%;
                    height: auto;
                }
            }
            .firstcolumn_tip{
                width: 100%;
                height: auto;
                background-color: #fff;
                text-align: center;
                img{
                    width: 90%;
                    height: auto;
                }
            }
            .columnBoxInnnerList{
                white-space: nowrap;
                padding: 0 20px;
            }
            .pushu_nav{
                width: 100%;
                overflow: hidden;
                padding-bottom: 20px;
                overflow-x: auto;
                span{
                    float: none;
                    margin: 0 auto 20px;
                }
            }
        }
        .showlist{
            text-align: center;
             margin-left: 0;
             width: 100%;
            .lilist{
              width: 100%;
            }
        }
        .rightBox{
            display: none;
        }
      .imgShadow{
        width: 100%;
      }
      .showlist .lilist .imgBox{
        width: 100%;
        padding-bottom: 82px;
      }
    }
</style>
